import React from "react";
import { useDispatch } from "react-redux";
import { logout } from "../features/userSlice";
import LogoutIcon from "@mui/icons-material/LogoutRounded";
import { Tooltip } from "@mui/material";
import { useMsal } from "@azure/msal-react";

// Sign-out control. With no children it's a round icon button (tooltip
// "Logout!"); pass children (e.g. "Sign out") and a className to render a
// labeled button instead. Either way the click does the same thing.
const LogoutButton = ({ children, className }) => {
  const { instance } = useMsal();

  const dispatch = useDispatch();

  const signOut = () => {
    dispatch(logout());
    instance.logoutRedirect();
  };

  if (children) {
    return (
      <button
        type="button"
        onClick={signOut}
        className={className || "app-btn app-btn-secondary"}
      >
        <LogoutIcon sx={{ fontSize: 18 }} />
        {children}
      </button>
    );
  }

  return (
    <>
      <Tooltip title="Logout!">
        <button
          type="button"
          onClick={signOut}
          aria-label="Sign out"
          className={className || "app-icon-btn hover:text-rose-600 dark:hover:text-rose-400"}
        >
          <LogoutIcon fontSize="small" />
        </button>
      </Tooltip>
    </>
  );
};

export default LogoutButton;
